import script from "./NewsPageFavorite.vue?vue&type=script&setup=true&lang=js"
export * from "./NewsPageFavorite.vue?vue&type=script&setup=true&lang=js"

import "./NewsPageFavorite.vue?vue&type=style&index=0&id=4d5bc00d&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4d5bc00d"]])

export default __exports__